module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADWSURBVHgBnZJBDoIwEEWnjQtZaDgCR/AGHsQF3kA8Abh059oN3khvAIm6BSUmuoFxBiHU0ibKT17SZOZnftsBUISILhESCXY6EjHhgUlU8Ikc7eJaoJtWetdjv6gxyGePbCJEeoIyu0KVX0zhdnwlSYeQcOF3cW/Axhn8L3+o0RvZKtKZAIynVidPTE0F4dhNpBN/RWR68+p5xzI7o0Vxuy29jy+28xrLInhSCHGj0Ws1B74KDtvQ04Y8addM66RO5qiMNmlpvDFHIA74WexWSfMOX0vyBogTM6w3eA5SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/warning.png
// module id = OY9L
// module chunks = 0